/**
 * useOwnNetworkFailuresWhileFocused — l'écran du design system qui a le focus dit lui-même ses échecs
 * réseau : les boîtes globales de l'ancien kit (« Pas de connexion Internet » d'`apiRequest`,
 * « Problème de connexion réseau » de l'intercepteur d'`App.js`) se taisent le temps de son focus.
 *
 * Le registre est celui de l'espace élève (`data/utility/networkFailureOwner`), tenu là au montage
 * (le live, l'activité, la messagerie). Ici au FOCUS : sous l'espace tuteur, la coquille et ses
 * onglets restent montés sous une route poussée, et un écran legacy poussé par-dessus (`edit-email`, la
 * salle legacy) ou un onglet resté legacy doit garder ses boîtes — il ne dit pas ses échecs.
 *
 * `enabled` à faux ne tient rien (un écran du registre ouvert en live, dont la salle répond seule).
 */
import { useFocusEffect } from "@react-navigation/native"
import { useCallback } from "react"

import { ownNetworkFailures } from "../../../../data/utility/networkFailureOwner"

export function useOwnNetworkFailuresWhileFocused(enabled = true): void {
    useFocusEffect(useCallback(() => (enabled ? ownNetworkFailures() : undefined), [enabled]))
}
